import React from 'react';
import AppImage from '@/components/ui/AppImage';

const testimonials = [
{
  id: 'test-001',
  name: 'Rohan Sharma',
  role: 'Senior Backend Engineer',
  company: 'Razorpay',
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1d90a96ad-1763299909299.png",
  avatarAlt: 'Rohan Sharma smiling professional headshot',
  quote:
  'I use TempMail for every third-party API signup. The inbox is instant, the address actually works with strict senders, and Pro paid for itself in the first week by saving me from inbox spam.',
  stars: 5
},
{
  id: 'test-002',
  name: 'Kavya Reddy',
  role: 'Product Designer',
  company: 'Groww',
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1254ae28e-1775254336764.png",
  avatarAlt: 'Kavya Reddy professional portrait with warm lighting',
  quote:
  'The permanent address feature is exactly what I needed for my portfolio site contact form. Clean UI, no clutter, and the custom domain selection makes it feel like a real company email.',
  stars: 5
},
{
  id: 'test-003',
  name: 'Marcus Chen',
  role: 'Indie Developer',
  company: 'Self-employed',
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1f21e31c2-1763292259568.png",
  avatarAlt: 'Marcus Chen developer portrait with glasses',
  quote:
  'Been on the Business plan for 3 months. The API access lets me pipe verification codes directly into my test automation. Delivery is fast — faster than Mailinator for most senders.',
  stars: 5
}];


export default function Testimonials() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {testimonials?.map((t) =>
      <div key={t?.id} className="card-elevated p-6 flex flex-col gap-4">
          {/* Stars */}
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5]?.map((s) =>
          <svg
            key={`star-${t?.id}-${s}`}
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill={s <= t?.stars ? '#FFB830' : 'none'}
            stroke={s <= t?.stars ? '#FFB830' : '#6B6B85'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round">
            
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
          )}
          </div>

          {/* Quote */}
          <p className="text-sm text-secondary-foreground leading-relaxed flex-1">
            &ldquo;{t?.quote}&rdquo;
          </p>

          {/* Author */}
          <div className="flex items-center gap-3 pt-3 border-t border-border">
            <div className="w-9 h-9 rounded-full overflow-hidden border border-border flex-shrink-0">
              <AppImage
              src={t?.avatarUrl}
              alt={t?.avatarAlt}
              width={36}
              height={36}
              className="w-full h-full object-cover" />
            
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground">{t?.name}</p>
              <p className="text-xs text-muted-foreground">
                {t?.role} · {t?.company}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>);

}